var map = {
	"./grammarBg.jpg": 788,
	"./headerBg.jpg": 297,
	"./listeningBg.jpg": 789,
	"./readingBg.jpg": 790,
	"./speakingBg.jpg": 791,
	"./vocabularyBg.jpg": 792,
	"./writingBg.jpg": 793
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 787;


//////////////////
// WEBPACK FOOTER
// ./src/components/report/evaluation_report/assets ^\.\/.*Bg\.jpg$
// module id = 787
// module chunks = 0